import React from 'react';
import * as _ from 'lodash';

export const withState = state => WrappedComponent => {
  class _withState extends React.Component {
    constructor(props) {
      super(props);
      if (_.isFunction(state)) {
        this.state = state(props);
      } else {
        this.state = state;
      }
    }

    updateStates = params => {
      this.setState(_.assign(this.state, params));
    };

    updateState = (key, val) => {
      this.setState({ [key]: val });
    };

    getState = key => {
      return this.state[key];
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          updateStates={this.updateStates}
          updateState={this.updateState}
          getState={this.getState}
        />
      );
    }
  }
  //eslintでエラーになるのでdisplaynameを作る
  _withState.displayName = `_withState(${getDisplayName(WrappedComponent)})`;
  return _withState;
};

const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};



// WEBPACK FOOTER //
// ./src/hocs/withState.js